import {
  audienceProperties,
  cloudflareProperties,
  TEST_RUN_COOKIE,
  validTestRunId,
  type TrafficProperties,
} from "./traffic-analytics";

export async function loadTrafficContext(): Promise<TrafficProperties> {
  try {
    const response = await fetch("/api/analytics/context", {
      credentials: "same-origin",
      cache: "no-store",
      signal: AbortSignal.timeout(2500),
    });
    if (!response.ok) throw new Error("Unavailable analytics context");
    const data: { properties?: TrafficProperties } = await response.json();
    if (
      !data.properties ||
      typeof data.properties !== "object" ||
      Array.isArray(data.properties)
    )
      throw new Error("Invalid analytics context");
    return data.properties;
  } catch {
    return {
      ...audienceProperties("unknown", null),
      ...cloudflareProperties(),
      cf_signal_scope: "unavailable",
      cf_signal_observed_at: null,
    };
  }
}

export function installTestTracking(client: {
  register: (properties: TrafficProperties) => void;
  capture: (event: string) => unknown;
}) {
  const controls = {
    beginTestRun(id = crypto.randomUUID()) {
      const runId = validTestRunId(id);
      if (!runId)
        throw new Error(
          "Use 1–80 letters, numbers, hyphens or underscores for a test run ID",
        );
      document.cookie = `${TEST_RUN_COOKIE}=${runId}; Path=/; SameSite=Lax; Secure; Max-Age=86400`;
      client.register(audienceProperties("test", runId));
      client.capture("test_run_started");
      return runId;
    },
    async endTestRun() {
      client.capture("test_run_ended");
      document.cookie = `${TEST_RUN_COOKIE}=; Path=/; SameSite=Lax; Secure; Max-Age=0`;
      client.register(await loadTrafficContext());
    },
  };
  Object.assign(window, { pdfparseAnalytics: controls });
  return controls;
}
